import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './Toolbar.css';

import { hideComponent } from '../../redux/helpers';

class Toolbar extends Component {
  constructor(args) {
    super(...args);
  }

  renderIcons(icons) {
    return icons.map(this.renderIcon);
  }

  renderIcon = (icon) => {
    const {
      name,
      props,
      title,
    } = icon;
    const {
      isCover,
      isFrontFlyLeaf,
      isBackFlyLeaf,
      droppedImagesLength,
    } = this.props;

    const deleteIcon = 'Delete image';
    const changeIcon = 'Change image';
    const fitImage = 'Fit image';
    const IconComponent = name;

    const isCoverPage = (isCover && title === deleteIcon) || (isCover && title === fitImage);
    const isFlyLeaf = (isFrontFlyLeaf || isBackFlyLeaf) && title === deleteIcon;
    const atLeastOneImage = droppedImagesLength === 1 && title === deleteIcon && !isFrontFlyLeaf && !isBackFlyLeaf;
    const emptyCanvas = droppedImagesLength === 0;
    const isProAndAutofill = hideComponent() && title === changeIcon;

    if (isCoverPage || isFlyLeaf || atLeastOneImage || emptyCanvas || isProAndAutofill) {
      return null;
    }

    return (
      <div key={`index-${title}`}>
        <IconComponent {...props} />
      </div>
    );
  }


  render() {
    const {
      icons,
      isAutofill,
      position,
    } = this.props;

    const toolbarClass = 'toolbar';

    if (!isAutofill) {
      return (
        <div className={toolbarClass} style={position}>
          {this.renderIcons(icons)}
        </div>
      );
    }
    return null;
  }
}

Toolbar.defaultProps = {
  icons: [],
  position: {},
  pageId: 0,
  placeholderId: 0,
  isCover: false,
  isFrontFlyLeaf: false,
  isBackFlyLeaf: false,
  isAutofill: false,
  coverType: '',
  lang: {},
  isFit: false,
};

Toolbar.propTypes = {
  position: PropTypes.object,
  icons: PropTypes.array,
  pageId: PropTypes.number,
  placeholderId: PropTypes.number,
  isCover: PropTypes.bool,
  isFrontFlyLeaf: PropTypes.bool,
  isBackFlyLeaf: PropTypes.bool,
  isAutofill: PropTypes.bool,
  coverType: PropTypes.string,
  lang: PropTypes.object,
  isFit: PropTypes.bool,
};

export default connect(state => ({
  isChange: state.editorUI.imageChange.isChange,
}))(Toolbar);



// WEBPACK FOOTER //
// ./src/components/toolbar/Toolbar.jsx